import request from "./common";

const authApi = {
    login: (data: LoginRequest): Promise<LoginResponse> => {
        return request<LoginResponse, LoginRequest>("/login", "POST", data);
    },
    logout: (): Promise<unknown> => {
        return request<unknown>("/logout", "POST", undefined, { baseURL: "/" });
    },
};

type LoginRequest = {
    username: string;
    password: string;
};

type LoginResponse = {
    mfaRequired: boolean;
    mfaSecret: {
        base64: string;
        qrcodePngBase64: string;
    };
};

export default authApi;
